


import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductList.css';
import Header from '../../headerFooter/header';
import HomeFooter from '../../homepage/homefooter';

// Optional: Import an icon if you want, or use text
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
// import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/data/products.json');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCardClick = (id) => {
    navigate(`/product/${id}`);
  };

  if (loading) return <div className="loader-container">Loading Satvic Essentials...</div>;
  if (error) return <div className="error-container">Unable to load products.</div>;

  return (
    <div className='product-list-wrapper'>
      <Header />
      
      <div className="product-list-container">
        <div className="product-list-header">
          <h1>Our Collection</h1>
          <p>Mindful tools for your Satvic journey</p>
        </div>

        <div className="product-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="product-card"
              onClick={() => handleCardClick(product.id)}
            >
              <div className="card-image-wrapper">
                <img
                  src={`/data/${product.images[0]}`}
                  alt={product.name}
                  className="card-image"
                  loading="lazy"
                />
              </div>
              
              <div className="card-details">
                <h2 className="card-name">{product.name}</h2>
                <p className="card-desc">{product.description}</p>
                
                <div className="card-footer">
                  <div className="price-group">
                    {product.discountPrice ? (
                      <>
                        <span className="price-current">₹{product.discountPrice}</span>
                        <span className="price-original">₹{product.price}</span>
                      </>
                    ) : (
                      <span className="price-current">₹{product.price}</span>
                    )}
                  </div>
                  
                  <button className="btn-card-action" aria-label="View Details">
                    +
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <HomeFooter />
    </div>
  );
};

export default ProductList;